var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDarkQuote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 132 95"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M0 56.822h27.906C21.705 69.545 15.503 82.277 9.302 95h27.906c6.494-12.58 12.996-25.153 19.49-37.734V.444C37.802.293 18.896.15 0 0v56.822zM75.745 0c-.15 18.938-.292 37.885-.443 56.822h28.349v.444l-18.604 37.29V95h28.349L132 57.71V0H75.745z"
  })));
}

export default SvgDarkQuote;